<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :form-component="searchFormComponent"
        show-date
        show-tourists
        tourists-label="tourist"
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import ExtraServiceSearchForm from '@/components/extraServices/search/forms/ExtraServiceSearchForm.vue'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            ExtraServiceSearchForm,
        },
    })
    export class ExtraServiceSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest

        searchForm = false

        @Watch('isSearchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        get searchFormComponent() {
            return resolveComponent('ExtraServiceSearchForm')
        }

        get isSearchActive() {
            return extraServicesRuntimeStore.searchActive
        }

        get locationLabel() {
            return `${extraServicesRuntimeStore.city.name}, ${extraServicesRuntimeStore.city.parentName}`
        }

        checkDisabled(on) {
            if (this.searchDisabled) return
            return on
        }
    }

    export default ExtraServiceSearchSummary
</script>
